<template>
  <div>
    <a
      class="button-import-spreadsheet cursor-pointer text-primary-90 text-primary-100:hover"
      @click="importFile()"
      :class="{
        'text-base-60 text-base-60:hover cursor-not-allowed disabled': isDisableWhenNotOwner
      }"
    ><i class="fas fa-upload"></i> Import spreadsheet</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import gaCategories from '@/constant/gaCategories'

export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['isDisableWhenNotOwner']),
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    importFile() {
      if (this.$store.state.isDisableEditPresentation) return
      this.$store.state.openModalImportSheet = true
      util.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Import Sheet File > Click Import',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.button-import-spreadsheet{
  &:hover{
    color: rgba(175, 175, 175, var(--tw-text-opacity));
  }
}
</style>
